
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DEFAULT_LINEAR_GRADIENT, GradientColor } from "@/types/colors";
import Gradient from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/Gradient.vue";

@Component({
  components: { Gradient }
})
export default class GradientPicker extends Vue {
  @Prop({
    default: () => DEFAULT_LINEAR_GRADIENT
  })
  value!: GradientColor;

  @Prop({ default: "linear" })
  type!: "linear" | "radial";

  onGradientSelected(gradient: GradientColor) {
    this.$emit("input", gradient);
  }
}
